export function generateStoreKey(contractId, includes = null) {
  const baseKey = `contractId_${contractId}`;

  if (!includes || includes.length === 0) {
    return baseKey;
  }

  const normalizedIncludes = [...includes]
    .filter(Boolean)
    .sort()
    .join(",");

  return `${baseKey}:${normalizedIncludes}`;
}



